export const messagesError: any = {
  blanckCoorName: 'El campo nombre de coordinador no debe estar vacío.',
  blanckCoorApellido: 'El campo apellido de coordinador no debe estar vacío.',
  validateCoorName:
    'El campo nombre de coordinador no debe tener números o caracteres especiales.',
  validateCoorApellido:
    'El campo apellido de coordinador no debe tener números o caracteres especiales.',
};
